import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {Panel} from "primereact/panel";
import axios from "axios"; import Cookies from "js-cookie";
import {Button} from "primereact/button";
import moment from "moment";

import HelpComponent from "../HelpComponent";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";

const UserShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id} = useParams();
  const [formData, setFormData] = useState({});
  const [accommodations, setAccommodations] = useState([]);
  const [selectedAccommodations, setSelectedAccommodations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if(formData.accommodations && formData.accommodations.length > 0 && accommodations && accommodations[0]) {
      let _selectedAccommodations = []
      formData.accommodations.map(function (accommodationId) {
        let _accommodation = accommodations.filter(item => item.id === accommodationId)[0]
        _selectedAccommodations.push(_accommodation)
      })
      setSelectedAccommodations(_selectedAccommodations)
    }
  }, [formData.accommodations, accommodations]);

  useEffect(() => {
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "user/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (process.env.REACT_APP_BRAND === 'felhomatrac') {
            axios({
              method: 'get',
              url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation",
              params: {},
              headers: {
                'Authorization': 'Bearer ' + Cookies.get("userToken"),
                "Sys-name": Cookies.get("instanceId"),
                "Preferred-locale": Cookies.get("language")
              }
            })
              .then(response => {
                setAccommodations(response.data.data.items)
              })
              .catch(error => {
                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
              })
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
        {formData.name}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button"
                  icon={"pi pi-pencil"}
                  onClick={() => navigate('/user/update/' + id)}
                  className="p-button-warning p-ml-2">
          </Button>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => navigate('/user')}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
        <HelpComponent type={"show_box"}/>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="email">{t('email')}</label>
              <span className="p-d-block p-text-bold">
                {formData.email}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="contact_email">{t('contact_email')}</label>
              <span className="p-d-block p-text-bold">
                {formData.contact_email}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="contact_phone">{t('contact_phone')}</label>
              <span className="p-d-block p-text-bold">
                {formData.contact_phone}
              </span>
            </div>
          </div>
          {formData.roles && formData.roles.toString().includes("API_USER") &&
            <div className={"p-col-12 p-lg-6"}>
              <div className="p-field p-fluid">
                <label htmlFor="password">{t('password')}</label>
                <span className="p-d-block p-text-bold">
                {formData.non_hashed_password}
              </span>
              </div>
            </div>
          }
        </div>
      </Panel>
      {process.env.REACT_APP_BRAND === 'felhomatrac' &&
        <Panel className={"p-mt-3"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center"}>
              <h2 className={"p-m-0"}>{t('accommodations')}</h2>
            </div>
            <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>

            </div>
          </div>
          <DataTable
            size={"small"}
            value={selectedAccommodations}
            emptyMessage={t('empty_message')}
            autoLayout={true}
            responsiveLayout={window.App.state.responsiveLayout}
            breakpoint="1365px"
            stripedRows
            dataKey="id"
          >
            
            <Column field="name" sortable header={t('name')}></Column>
            <Column field="created_at_snapshot" sortable header={t('created_at')}
                    sortField={"created_at"}
                    body={(rowData) => {
                      if (rowData.created_at_snapshot !== null) {
                        return (
                          <span>{moment.utc(rowData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                        )
                      }
                    }}></Column>
            <Column field="updated_at_snapshot" sortable header={t('updated_at')}
                    sortField={"updated_at"}
                    body={(rowData) => {
                      if (rowData.updated_at_snapshot !== null) {
                        return (
                          <span>{moment.utc(rowData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                        )
                      }
                    }}></Column>
          </DataTable>
        </Panel>
      }
    </>
  )
}
export default withTranslation('common')(UserShowComponent);
